import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { UnauthGuard } from 'app/core/guards/unauth.guard';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
    {
      path: MenuItemPath.get(MenuItem.login),
      component: LoginComponent,
      canActivate: [UnauthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})

export class LoginRoutingModule { }
